import storage, { removeToken } from '@/utils/auth';
import { login, isInspectionToken } from '@/api/user';
import Util from "@/components/js/util.js";

const getDefaultState = () => ({
  token: storage.token || '',
  data: storage.user || {},
});

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    storage.token = token;
    state.token = token;
  },
  SET_DATA: (state, data) => {
    storage.user = data;
    state.data = data;
    wps.ribbonUI.Invalidate();
    window.close();
  },
  SET_CHECKED: (state, data) => {
    state.checked = data;
  },
};

const actions = {
  async login({ commit }, userInfo) {

    const res = await login({ ...userInfo });
    // 必须先存储token
    console.log(res);
    const { ret_code } = res;
    if(ret_code == 0) {
      commit('SET_TOKEN', res.token);
      commit('SET_DATA', {...res, ...userInfo });
    }
  },
  // user logout
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        removeToken(); // must remove  token  first
        commit('RESET_STATE');
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },
  // 检查token是否失效
  async inspectionToken() {
    if (!localStorage.wps) return;

    const { token } = JSON.parse(localStorage.wps);
    if (!token) return;

    const res = await isInspectionToken({ token: token });
    console.log(res, '+++++++++++++')
    if(res.ret_code == 1) {
      window.close();
      alert('检查到您的账号在其它地方登录，请重新登录！');

      wps.ShowDialog(
        Util.GetUrlPath() + "login",
        "登录",
        200 * window.devicePixelRatio,
        200 * window.devicePixelRatio,
        true
      );
      }
    
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit('RESET_STATE');
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
};
